import axios from "axios";
import {getStoredSessionId} from "../utils/sessionStore";

const loadRandomPosition = async (lower_eval_limit, upper_eval_limit, lower_move_limit, upper_move_limit) => {
    try {
        let response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/game/random-position?lower_eval_limit=${lower_eval_limit}&upper_eval_limit=${upper_eval_limit}&lower_move_limit=${lower_move_limit}&upper_move_limit=${upper_move_limit}`)
        if (!response.ok) {
            throw new Error(`Http error status returned: ${response.status}`)
        }
        return await response.json()
    } catch (e) {
        console.error("Something went wrong: ", e)
    }

};

export const loadShuffledBoard = async () => {
    try {
        let response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/game/shuffle-board`)
        if (!response.ok) {
            throw new Error(`Http error status returned: ${response.status}`)
        }
        return await response.json()
    } catch (e) {
        console.error("Something went wrong: ", e)
    }
}

export const fetchAnalysis = async (gameId) => {
    let response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/game/analysis/${gameId}`
        , {withCredentials: true});

    return await response.data
}

export const fetchPgnAnalysis = async (initialPosition, moves) => {
    let response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/game/analysis/pgn`,
        {initialPosition, moves}, {withCredentials: true});

    return await response.data
}

// Analyses the positions after fromPly..toPly moves - used to analyse a game in chunks and show progress
export const fetchAnalysisRange = async (initialPosition, moves, fromPly, toPly) => {
    let response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/game/analysis/range`,
        {initialPosition, moves, fromPly, toPly}, {withCredentials: true});

    return await response.data
}

export const fetchSingleMoveAnalysis = async (initialPosition, moves) => {
    let response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/game/analysis/single-move`
        , {initialPosition: initialPosition, moves: moves}, {withCredentials: true});

    return await response.data
}

export const offerRematch = async (previousGameId) => {
    return await axios.post(`${process.env.REACT_APP_BACKEND_URL}/game/offer-rematch`,
        {previousGameId, sessionId: getStoredSessionId()})

}

export const acceptDenyRematch = async (offerId, accept) => {
    return await axios.post(`${process.env.REACT_APP_BACKEND_URL}/game/handle-rematch-offer`,
        {offerId, sessionId: getStoredSessionId(), accept})
}

export default loadRandomPosition;